module.exports = __webpack_public_path__ + "img/yiliao.32f9f50e.svg";